import type { RawProductAttribute } from '~~/types/commercetools';

export const getTranslatedAttributeValue = (rawAttribute: RawProductAttribute, commerceToolsLocale: string) => {

  if ('attributeDefinition' in rawAttribute && rawAttribute.attributeDefinition) {

    if (rawAttribute.attributeDefinition.type.name === 'ltext') {

      return rawAttribute.value[commerceToolsLocale];

    }

    if (rawAttribute.attributeDefinition.type.name === 'lenum') {

      return rawAttribute.value.label[commerceToolsLocale];

    }

    return rawAttribute.value;

  }

  if (typeof rawAttribute.value === 'object' && rawAttribute.value !== null) {

    if ('label' in rawAttribute.value) {

      return rawAttribute.value.label?.[commerceToolsLocale];

    }

    return rawAttribute.value?.[commerceToolsLocale];

  }

  return rawAttribute.value;

};
